import IChannelPhoneSettings from "@/module/main/dto/IChannelPhoneSettings";
import ICallRequest from "@/module/main/dto/ICallRequest";

export default class ChannelPhoneSettings implements IChannelPhoneSettings {
    constructor(public callRequest?: ICallRequest,
                public notificationEndpoint?: string) {
    }
}
